import ClipLoader from "react-spinners/ClipLoader";

const Cliploader = (loading) => {
  //console.log("loading recibido: ", loading.loading);
  if (!loading.loading) return null;
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(255, 255, 255, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}>
      <ClipLoader
        color="#00205B"
        size={90}
        cssOverride={{
          borderWidth: "4px",
        }}></ClipLoader>
    </div>
  );
};

export default Cliploader;
